/**
 * Jun-2026 (User-Wunsch) — B2B-Anfragen-Übersicht pro Standort.
 *
 * Eingehende (an mich/meinen Account gerichtete) und ausgehende (von mir
 * gestellte) Kauf-/Vermittlungsanfragen aus dem B2B-Handel. Die Liste +
 * Detail-Logik liegt in `B2BDealsPanel` und wird auch im Dashboard-Bereich
 * „Aufgaben & Hinweise" genutzt.
 *
 * Aufruf: ``/dealer/b2b-anfragen`` (Deep-Link aus „Was zu tun ist": ?deal=&dir=).
 */
import { Link, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { Handshake, Settings } from "lucide-react";
import B2BDealsPanel from "../components/dealer/B2BDealsPanel";
import B2BTradeRulesModal from "../components/dealer/B2BTradeRulesModal";

export default function B2BDealsPage() {
    const [params] = useSearchParams();
    const initialDirection = params.get("dir") === "outgoing" ? "outgoing" : "incoming";
    const initialDealId = params.get("deal") || null;
    const [rulesOpen, setRulesOpen] = useState(false);

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="bg-[#111827] text-white">
                <div className="max-w-5xl mx-auto px-4 md:px-8 py-8">
                    <Link to="/dashboard?tab=tasks" className="text-xs text-gray-400 hover:text-white inline-flex items-center gap-1" data-testid="back-to-dashboard">← Dashboard</Link>
                    <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight flex items-center gap-3" data-testid="b2b-deals-title">
                        <Handshake className="w-9 h-9 text-[#FFCC00]" /> B2B-Anfragen
                        {/* Jul-2026 (User-Wunsch) — Zahnrad: Kauf/Vermittlung-Regeln je Marke/Modell. */}
                        <button type="button" onClick={() => setRulesOpen(true)}
                            className="ml-auto text-gray-400 hover:text-[#FFCC00] transition-colors"
                            title="Kauf / Vermittlung — Regeln (Zahnrad)" data-testid="b2b-trade-rules-gear">
                            <Settings className="w-6 h-6" />
                        </button>
                    </h1>
                    <p className="text-sm text-gray-400 mt-2 truncate max-w-full">Kauf- und Vermittlungsanfragen anderer Händler annehmen, ablehnen oder kommunizieren.</p>
                </div>
            </div>

            <div className="max-w-5xl mx-auto px-4 md:px-8 py-6">
                <B2BDealsPanel initialDirection={initialDirection} initialDealId={initialDealId} />
            </div>
            {rulesOpen && <B2BTradeRulesModal onClose={() => setRulesOpen(false)} />}
        </div>
    );
}
